import * as ACTION from "./SetViewTypeActionType";

const setViewTypeSuccess = (viewType) => {
  return {
    type: ACTION.SET_VIEW_TYPE,
    payload: viewType,
  };
};

export const setViewTypeAction = (viewType) => {
  return async function (dispatch) {
  dispatch(setViewTypeSuccess(viewType));
  }
};
